import React, { useState, useEffect } from 'react';
import { navigate } from '../utils/navigation';
import apiService from '../services/apiService';
import Layout from '../components/Layout';

const MyPrenups = () => {
  const [myPrenups, setMyPrenups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadMyPrenups();
  }, []);

  // Load user's prenups
  const loadMyPrenups = async () => {
    try {
      setIsLoading(true);
      const response = await apiService.getPrenups();
      if (response.success) {
        setMyPrenups(response.data.prenups || []);
      }
    } catch (error) {
      console.error('Error loading prenups:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Delete prenup
  const handleDeletePrenup = async (prenupId) => {
    if (window.confirm('هل أنت متأكد من حذف هذه الاستمارة؟')) {
      try {
        const response = await apiService.deletePrenup(prenupId);
        if (response.success) {
          alert('تم حذف الاستمارة بنجاح');
          loadMyPrenups();
        } else {
          alert('حدث خطأ في حذف الاستمارة');
        }
      } catch (error) {
        console.error('Delete error:', error);
        alert('حدث خطأ في حذف الاستمارة');
      }
    }
  };

  const handleViewPrenup = (prenupId) => {
    navigate(`/my-prenups/${prenupId}`);
  };

  const handleEditPrenup = (prenupId) => {
    navigate(`/create-prenup?edit=${prenupId}`);
  };

  if (isLoading) {
    return (
      <Layout>
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-auto text-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="sr-only">جاري التحميل...</span>
              </div>
              <h5>جاري تحميل الاستمارات...</h5>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>استماراتي</h2>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/create-prenup')}
          >
            إضافة استمارة جديدة
          </button>
        </div>
        <hr />

      {myPrenups.length > 0 ? (
        <div className="row">
          {myPrenups.map((prenup, index) => (
            <div key={index} className="col-md-6 col-lg-4 mb-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">
                    {prenup.fullName || `${prenup.FIRSTNAME} ${prenup.SECONDNAME} ${prenup.THIRDNAME || ''}`.trim()}
                  </h5>
                  <p className="card-text">
                    <strong>الرقم القومي:</strong> {prenup.NID || prenup.PASSPORTNUMBER || 'غير محدد'}<br />
                    <strong>رقم الوثيقة:</strong> {prenup.documentNumber || 'غير محدد'}<br />
                    <strong>تاريخ الإنشاء:</strong> {new Date(prenup.createdAt).toLocaleDateString('ar-EG')}
                  </p>
                  <div className="mb-3">
                    <span className={`badge badge-lg ${
                      prenup.status === 'approved' ? 'badge-success' : 
                      prenup.status === 'rejected' ? 'badge-danger' : 
                      prenup.status === 'sample_replacement' ? 'badge-warning' :
                      prenup.status === 'printed' ? 'badge-info' :
                      'badge-secondary'
                    }`}>
                      {prenup.status === 'pending' ? 'منتظر نتيجة الHVD' :
                       prenup.status === 'approved' ? 'جاهز للطباعة' :
                       prenup.status === 'rejected' ? 'مرفوضة' :
                       prenup.status === 'sample_replacement' ? 'مطلوب إستبدال العينة' :
                       prenup.status === 'printed' ? 'تم الطباعة' : 
                       prenup.status || 'جاهز للطباعة'}
                    </span>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="btn-group w-100" role="group">
                    <button 
                      className="btn btn-info btn-sm"
                      onClick={() => handleViewPrenup(prenup._id)}
                    >
                      <>عرض</>
                    </button>
                    {(prenup.status === 'pending' || prenup.status === 'sample_replacement' || !prenup.status) && (
                      <button 
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEditPrenup(prenup._id)}
                      >
                        <>تعديل</>
                      </button>
                    )}
                    <button 
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeletePrenup(prenup._id)}
                    >
                      <>حذف</>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="card">
          <div className="card-body text-center">
            
            <h4>لا توجد استمارات</h4>
            <p className="text-muted">لم تقم بإنشاء أي استمارات بعد</p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/create-prenup')}
            >
              إنشاء استمارة جديدة
            </button>
          </div>
        </div>
      )}
      </div>
    </Layout>
  );
};

export default MyPrenups;
